import { TimeTypes as CommonTimeTypes } from '../common/enums/TimeTypes'

export class TimeTypes extends CommonTimeTypes {
}
